export default __webpack_public_path__ + "static/media/instagram-icon.fd4c8f80.svg";